module.exports = __webpack_public_path__ + "static/media/bg-mob-3.f7eebc5f.jpg";